import { post } from '../request'

//设备故障列表
export const queryTroubleList = params => {
    return post('/entity/queryTroubleList', params)
}